import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from "@apollo/client";
import Context from 'common/context/component'

// Material-UI
import {
    StylesProvider
} from '@material-ui/core/styles'

import App from './app.js'

// Styles
import 'common/scss/styles.scss'
import graphqlClient from 'common/api/graphql'

function AppRoot() {
    return (
        <StylesProvider injectFirst>
            <ApolloProvider client={graphqlClient}>
                <BrowserRouter>
                    <Context>
                        <App />
                    </Context>
                </BrowserRouter>
            </ApolloProvider>
        </StylesProvider>
    )
}

ReactDOM.render(
    <AppRoot />,
    document.getElementById('root')
);

